let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j8LyV")).then(() => parcelRequire('5LTxU'));